import { Portal } from "@mui/material";
import React, { useState } from "react";
import useSnackbar from "@hyro-components/hooks/useSnackbar";
import { INITIATE_CALL_WENT_WRONG, RECEIVE_CALL_SHORTLY } from "@phrasing";
import { SEVERITY_VARIANTS } from "@consts";
import CallMeDialog from "../call-me-dialog/CallMeDialog";
import HyroFeedbackMessage from "@hyro-components/HyroFeedbackMessage";
import useAppStore from "src/stores/appStore";
import { pageNameSelector, selectedAccountIdSelector, assistantIdSelector, isOutboundAgentSelector } from "src/stores/selectors/appSelectors";
import { trackEvent, ANALYTICS_EVENTS } from "@analytics";
import { useInitiateCall } from "src/queries/hooks/assistants";

const CallMeManager = ({ phoneDialogOpen, setPhoneDialogOpen, branchName, releaseName, hideBackdrop, PaperProps, variant }) => {
  const [callRequestSent, setCallRequestSent] = useState(false);
  const pageName = useAppStore(pageNameSelector);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [
    isSnackbarOpen,
    snackbarMessage,
    addSnackbarMessage,
    exitSnackbar,
    closeSnackbar
  ] = useSnackbar();
  const accountId = useAppStore(selectedAccountIdSelector);
  const assistantId = useAppStore(assistantIdSelector);
  const isOutboundAgent = useAppStore(isOutboundAgentSelector);
  const { mutateAsync: initiateCall } = useInitiateCall();

  const handleCallMe = async ({ phoneNumber, callerId, site, businessHoursMode, outboundJson }) => {
    try {
      trackEvent(ANALYTICS_EVENTS.GENERAL.CALL_ME_CLICKED, { accountId, assistantId });
      setCallRequestSent(true);
      const data = { phoneNumber, callerId, site, branchName, releaseName, businessHoursMode };
      if (isOutboundAgent) {
        data.outboundJson = JSON.parse(outboundJson);
        data.outboundAssistant = true;
      }
      await initiateCall({ ...data, accountId, assistantId }, { pageName });
      setCallRequestSent(false);
      setPhoneDialogOpen?.(false);
      setSnackbarSeverity(SEVERITY_VARIANTS.SUCCESS);
      addSnackbarMessage(RECEIVE_CALL_SHORTLY);
    } catch (e) {
      console.log("error", e);
      setCallRequestSent(false);
      setSnackbarSeverity(SEVERITY_VARIANTS.ERROR);
      addSnackbarMessage(INITIATE_CALL_WENT_WRONG);
    }
  };

  return (
    <>
      {phoneDialogOpen ? (
        <CallMeDialog
          callRequestSent={callRequestSent}
          isOpen={phoneDialogOpen}
          onClose={() => setPhoneDialogOpen?.(false)}
          handleCallMe={handleCallMe}
          hideBackdrop={hideBackdrop}
          PaperProps={PaperProps}
          variant={variant}
          addSnackbarMessage={addSnackbarMessage}
          setSnackbarSeverity={setSnackbarSeverity}
        />
      ) : null}
      <Portal>
        <HyroFeedbackMessage
          message={snackbarMessage}
          severity={snackbarSeverity}
          showFeedback={isSnackbarOpen}
          onExited={exitSnackbar}
          closeFeedback={closeSnackbar}
        />
      </Portal>
    </>
  );
};

export default CallMeManager;
